import { useState, useEffect, useCallback, RefObject } from 'react';
import { loadGoogleMapsPlaces } from './loadGoogleMapsPlaces';

type Autocomplete = google.maps.places.Autocomplete;
type PlaceResult = google.maps.places.PlaceResult;

export const useAddressAutocomplete = (inputRef: RefObject<HTMLInputElement>) => {
  const [autocomplete, setAutocomplete] = useState<Autocomplete | undefined>(undefined);
  const [place, setPlace] = useState<PlaceResult | undefined>(undefined);

  const createAutocomplete = useCallback(() => {
    inputRef.current &&
      setAutocomplete(
        new window.google.maps.places.Autocomplete(inputRef.current, {
          fields: ['address_components']
        })
      );
  }, [inputRef]);

  useEffect(() => {
    if (!autocomplete) {
      loadGoogleMapsPlaces(createAutocomplete);
    }
  }, [autocomplete, createAutocomplete]);

  const handlePlaceChange = useCallback(() => {
    const place = autocomplete?.getPlace();
    if (place) {
      setPlace(place);
    }
  }, [autocomplete]);

  useEffect(() => {
    const listener = autocomplete?.addListener('place_changed', handlePlaceChange);
    return () => listener?.remove();
  }, [autocomplete, handlePlaceChange]);

  return place;
};
